/*
  Doppelklick auf einen Eintrag in der Mitarbeitenden-Ansicht: nur anzeigen.
  Bewusst nicht der Schicht-Editor mit gesperrten Feldern - hier gibt es keinen
  Speicherweg, den man vergessen könnte zu sperren.
*/

import React from "react";
import AppButton from "../../../design-system/components/AppButton";
import AppDialog from "../../../design-system/components/AppDialog";
import AppDialogBody from "../../../design-system/components/AppDialogBody";
import AppDialogFooter from "../../../design-system/components/AppDialogFooter";
import AppDialogHeader from "../../../design-system/components/AppDialogHeader";
import AppText from "../../../design-system/components/AppText";

export default function EntryDetailsDialog({ details, onClose }) {
  return (
    <AppDialog open={Boolean(details)} onClose={onClose} size="sm">
      <AppDialogHeader title={details?.title || ""} subtitle={details?.subtitle || ""} />
      <AppDialogBody>
        <dl className="employee-entry-details">
          {(details?.rows || []).map((row) => (
            <div key={row.label} className="employee-entry-details__row">
              <AppText as="dt" variant="label-2" tone="secondary">
                {row.label}
              </AppText>
              <AppText as="dd" variant="body-1">
                {row.value}
              </AppText>
            </div>
          ))}
        </dl>
      </AppDialogBody>
      <AppDialogFooter>
        <AppButton variant="primary" onClick={onClose}>
          Schliessen
        </AppButton>
      </AppDialogFooter>
    </AppDialog>
  );
}
